var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingsAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.36113C2.89543 5.36113 2 6.23635 2 7.31599V20.0451C2 21.1248 2.89543 22 4 22H9V19.0677C9 17.4483 10.3431 16.1354 12 16.1354C13.6569 16.1354 15 17.4483 15 19.0677V22H20C21.1046 22 22 21.1248 22 20.0451V7.31599C22 6.23635 21.1046 5.36113 20 5.36113H17L13.2494 2.42837C12.519 1.85721 11.481 1.85721 10.7506 2.42837L7 5.36113H4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingsAlt1);
export default __webpack_public_path__ + "static/media/buildings-alt-1.89221bdeef0b968fcf76d05aa221a2ca.svg";
export { ForwardRef as ReactComponent };